var map = {
	"./data-cs.json": 47552,
	"./data-de.json": 71081,
	"./data-en.json": 46769,
	"./data-es.json": 51925,
	"./data-fr.json": 55406,
	"./data-it.json": 22336,
	"./data-ja.json": 62612,
	"./data-ko.json": 50307,
	"./data-pl.json": 98300,
	"./data-ru.json": 3096,
	"./data-uk.json": 37366,
	"./data-zh.json": 59206
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74550;